import { Box, SlideFade, Stack, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import { useAuth } from '../../../context/authContext';
import { getSinglePoll, vote } from '../service';
import { LeafPoll } from 'react-leaf-polls';
import 'react-leaf-polls/dist/index.css';
import FullPageLoader from '../../../components/FullPageLoader';

const { POLLS } = PROTECTED_PATHS;

const customTheme = {
  textColor: 'black',
  textSize: '2rem',
  mainColor: '#569ff3',
  backgroundColor: 'rgb(255,255,255)',
  alignment: 'center',
};

export const Vote = () => {
  const { userInfo } = useAuth();
  const { userId } = userInfo;
  const { voteID } = useParams();
  const [poll, setPoll] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSinglePoll(setLoading, userId, voteID, setPoll);
  }, [userId, voteID]);

  console.log('poll', poll);

  const options = poll?.answerOptions?.map((option, index) => ({ id: index, text: option, votes: 0 })) || [];

  console.log('options', options);

  const handleVote = (item, results) => {
    console.log('item ', item);
    console.log('results ', results);
    const payload = { pollId: poll._id, userId, response: item.text };
    vote(setLoading, payload);
  };

  return loading ? (
    <FullPageLoader />
  ) : (
    <SlideFade in={true} offsetX='2000px'>
      <Stack>
        <Box shadow='sm'>
          <Container>
            <Header goto={POLLS} />
          </Container>
        </Box>
        <Container className='poll'>
          {/* {ongoingPolls?.map((poll) => (
          <Stack key={v4()}>
            <Heading fontWeight='600' fontSize='1.2rem'>
              {poll?.title}
            </Heading>
            <Text>Posted by Estate manager at {poll?.timeOfPost}</Text>

            {poll?.options?.map((option) => (
              <Box py='3' key={v4()}>
                {/* <Text fontWeight={'600'}>{option?.optionName}</Text> 
                <ProgressBar
                  handleVote={handleVote}
                  key={v4()}
                  bgcolor={option?.color}
                  optionName={option?.optionName}
                  completed={0 || option?.percentageVote}
                />
              </Box>
            ))}
          </Stack>
        ))} */}
          <Text py='2' fontSize={'1.3rem'}>
            {poll?.title}
          </Text>
          <Text pt='3' pb='1' fontSize={'1rem'} fontWeight='600'>
            {poll?.description}
          </Text>
          <LeafPoll type='multiple' results={options} theme={customTheme} onVote={handleVote} isVoted={false} />
        </Container>
      </Stack>
    </SlideFade>
  );
};
